/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Axios, { AxiosRequestConfig } from "axios";

const axios = Axios.create();

axios.interceptors.request.use((req) => {
  req.baseURL = process.env.VUE_APP_SALUTARIA_API_URL + "/api/notification";
  req.headers!.authorization = `Bearer ${localStorage.authToken}`;
  // req.headers.origin = process.env.BASE_URL;
  return req;
});
export default {
  getListNotification() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/list",
    };
    return axios(options);
  },
  setReadNotification(id: number | null) {
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/read/" + id,
    };
    return axios(options);
  },
  getCountNewNotif() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/new",
    };
    return axios(options);
  },
};
